import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import Routes from 'Routes';

const SearchResultItemContainer = styled.div`
  margin: 24px 0;
  position: relative;
  border-bottom: 1px solid #DBDEE2;
`;

const StyledTitleContainer = styled.div`
  width: 80%;
`;

const StyledLink = styled(Link)`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
  color: #484848;
`;

const StyledTag = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 40px;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  background: #F4F8FF;
  color: #5C8DF3;
  text-transform: captialize;
  padding: 5px 20.5px;
`;

const StyledDetails = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #484848;
  padding: 17px 0 24px;
`;

const ExhibitorItem = ({
  id,
  name,
  details,
}) => (
  <SearchResultItemContainer>
    <StyledTitleContainer>
      <StyledLink to={Routes.booth(id)}>
        { name }
      </StyledLink>
    </StyledTitleContainer>
    <StyledTag>
      Tech Ventures
    </StyledTag>
    <StyledDetails>
      {ReactHtmlParser(details)}
    </StyledDetails>
  </SearchResultItemContainer>
);

ExhibitorItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  details: PropTypes.string,
};

ExhibitorItem.defaultProps = {
  details: '',
};

export default ExhibitorItem;
